import { $api } from '@/shared/api/axiosInstance';

export const logoutQuery = async () => {
    const url = `/api/v1/logout`;

    const { data } = await $api.put(url, null, {
        validateStatus: (status) => status === 200 || status === 302,
        maxRedirects: 0,
    });

    return data;
};
